(function(){
'use strict';
if (window.__saettoMorph) return; window.__saettoMorph = 2;
var reduced = false; try { reduced = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch(e){}
if (reduced || (window.Shopify && Shopify.designMode)) return;
var SEC = document.querySelector('.saetto-hero'); if(!SEC) return;
var STAGE = SEC.querySelector('.saetto-hero__stage');
var IMG = SEC.querySelector('.saetto-hero__media img');
var CV = SEC.querySelector('.saetto-hero__morph');
var ER = SEC.querySelector('.saetto-hero__erode');
var GPNG = SEC.querySelector('.saetto-hero__glasses');
var INNER = SEC.querySelector('.saetto-hero__inner');
var ENDCAP = SEC.querySelector('.saetto-hero__endcap');
var CUE = SEC.querySelector('.saetto-hero__cue');
if(!STAGE || !IMG || !CV || !ER) return;
var SCRUB = ER.getAttribute("data-scrub");
var GURL = CV.getAttribute('data-glasses'); if(!GURL) return;
try { var tc = document.createElement('canvas'); if(!(tc.getContext('webgl')||tc.getContext('experimental-webgl'))) return; } catch(e){ return; }
var MOBILE = Math.min(screen.width, innerWidth) < 750;
var CELL = MOBILE ? 9 : 6;
var DPR = Math.min(devicePixelRatio||1, MOBILE?1.5:1.75);
var renderer, scene, cam, pts, lines, uni;
var ex, holes, hx2, brush;
var bgL=null, subL=null, rainP=null;
var PLH=[], pmBaked=-1;
var VHC = window.innerHeight;
var VID=null, vidReady=false, vidDur=0, VSEG=0.55, lastVT=-1;
var vidTarget=0, vidSeeking=false, vidSeekT=0;
var PL = [], N=0, built=false, failed=false;
var imgW=1, imgH=1, W=0, H=0, lastP=-2, lastPm=-2, raf=0, t0=performance.now();
var fpsE=60, lastT=0, degraded=0;
function ss(a,b,x){ x=(x-a)/(b-a); x=x<0?0:x>1?1:x; return x*x*(3-2*x); }
function clamp(x,a,b){ return x<a?a:x>b?b:x; }
function loadThree(cb){ if(window.THREE) return cb();
  var s=document.createElement('script'); s.src='https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
  s.onload=cb; s.onerror=function(){ var s2=document.createElement('script'); s2.src=s.src; s2.onload=cb; s2.onerror=function(){ failed=true; try{ SEC.classList.remove('sh-scrub'); IMG.style.opacity=''; }catch(e){} }; document.head.appendChild(s2); }; document.head.appendChild(s); }
function loadImg(u){ return new Promise(function(res,rej){ var im=new Image(); im.crossOrigin='anonymous';
  im.onload=function(){res(im)}; im.onerror=rej; im.src=u; }); }
function coverRect(nw,nh,cw,ch){ var sc=Math.max(cw/nw, ch/nh); var sw=cw/sc, sh=ch/sc; return [ (nw-sw)/2, (nh-sh)/2, sw, sh ]; }
function build(imA, imB){
  W=STAGE.clientWidth; H=STAGE.clientHeight;
  // ---- erode canvas + sampling at stage size
  ER.width=W; ER.height=H; ex=ER.getContext('2d');
  var cr = coverRect(imA.naturalWidth, imA.naturalHeight, W, H); ER.__cov=cr; ER.__img=imA;
  var oc=document.createElement('canvas'); oc.width=W; oc.height=H;
  var ox=oc.getContext('2d',{willReadFrequently:true});
  ox.drawImage(imA, cr[0],cr[1],cr[2],cr[3], 0,0,W,H);
  var data;
  try { data = ox.getImageData(0,0,W,H).data; } catch(e){ failed=true; return; }
  holes=document.createElement('canvas'); holes.width=Math.ceil(W/2); holes.height=Math.ceil(H/2); hx2=holes.getContext('2d');
  var BR=Math.ceil(CELL*2.5);
  brush=document.createElement('canvas'); brush.width=brush.height=BR*2;
  var bx=brush.getContext('2d'); var g1=bx.createRadialGradient(BR,BR,0,BR,BR,BR);
  g1.addColorStop(0,'rgba(0,0,0,1)'); g1.addColorStop(0.55,'rgba(0,0,0,0.85)'); g1.addColorStop(1,'rgba(0,0,0,0)');
  bx.fillStyle=g1; bx.fillRect(0,0,BR*2,BR*2);
  // ---- particles (2D list + GL buffers share t)
  PL.length=0; PLH.length=0; pmBaked=-1;
  var pa=[], ca=[], ts=[];
  var x,y,idx,r,g,b,l;
  for(y=Math.floor(CELL/2); y<H; y+=CELL){ for(x=Math.floor(CELL/2); x<W; x+=CELL){
    idx=(y*W+x)*4;
    r=data[idx]/255; g=data[idx+1]/255; b=data[idx+2]/255; l=0.299*r+0.587*g+0.114*b;
    var t = 0.04 + 0.52*(y/H) + 0.40*Math.random();
    t = t>0.98?0.98:t;
    PL.push({hx:x, hy:y, t:t, baked:0});
    if(((x/CELL)|0)%2===0 && ((y/CELL)|0)%2===0){ PLH.push({hx:x, hy:y, t:t, baked:0}); }
    pa.push(x/W, y/H, (l-0.5)); ca.push(r,g,b); ts.push(t);
  }}
  N = PL.length; if(N<1000){ failed=true; return; }
  // ---- glasses sampling + transparent PNG
  var B = (function(im){ var w=Math.min(1100, im.naturalWidth), h=Math.round(im.naturalHeight*w/im.naturalWidth);
    var c=document.createElement('canvas'); c.width=w; c.height=h; var cx2=c.getContext('2d',{willReadFrequently:true});
    cx2.drawImage(im,0,0,w,h); return {c:c, x:cx2, d:cx2.getImageData(0,0,w,h), w:w, h:h}; })(imB);
  var bd=B.d.data, cs2=6, corn=[];
  [[0,0],[B.w-cs2,0],[0,B.h-cs2],[B.w-cs2,B.h-cs2]].forEach(function(o){ for(var yy=0;yy<cs2;yy++)for(var xx=0;xx<cs2;xx++){ var ii=((o[1]+yy)*B.w+(o[0]+xx))*4; corn.push(bd[ii],bd[ii+1],bd[ii+2]); } });
  var br2=0,bg2=0,bb2=0,cn=corn.length/3;
  for(var k2=0;k2<corn.length;k2+=3){ br2+=corn[k2]; bg2+=corn[k2+1]; bb2+=corn[k2+2]; } br2/=cn; bg2/=cn; bb2/=cn;
  var tgt=[];
  function collect(th){ tgt.length=0; for(var y2=0;y2<B.h;y2+=2){ for(var x2=0;x2<B.w;x2+=2){ var i2=(y2*B.w+x2)*4;
    if(bd[i2+3]<200) continue; var dr=bd[i2]-br2, dg=bd[i2+1]-bg2, db=bd[i2+2]-bb2;
    if(Math.sqrt(dr*dr+dg*dg+db*db)>th) tgt.push(x2/B.w, y2/B.h, bd[i2]/255, bd[i2+1]/255, bd[i2+2]/255); } } }
  collect(40); if(tgt.length/5<2500) collect(22); if(tgt.length/5<800){ failed=true; return; }
  var M=tgt.length/5;
  // transparent png for the finish
  if(GPNG && !GPNG.getAttribute('src')){
    try {
      var full=B.d;
      for(var pi=0; pi<full.data.length; pi+=4){ var dr2=full.data[pi]-br2, dg2=full.data[pi+1]-bg2, db2=full.data[pi+2]-bb2;
        var dd2=Math.sqrt(dr2*dr2+dg2*dg2+db2*db2);
        if(dd2<=36){ full.data[pi+3]=0; } else if(dd2<62){ full.data[pi+3]=Math.min(full.data[pi+3], Math.round(255*(dd2-36)/26)); } }
      B.x.putImageData(full,0,0);
      GPNG.setAttribute('src', B.c.toDataURL('image/png'));
    } catch(e){}
  }
  // ---- GL buffers
  var pos=new Float32Array(N*3), aB=new Float32Array(N*3), colA=new Float32Array(N*3), colB=new Float32Array(N*3), seed=new Float32Array(N*4);
  for(var p2=0;p2<N;p2++){
    pos[p2*3]=pa[p2*3]; pos[p2*3+1]=pa[p2*3+1]; pos[p2*3+2]=pa[p2*3+2];
    colA[p2*3]=ca[p2*3]; colA[p2*3+1]=ca[p2*3+1]; colA[p2*3+2]=ca[p2*3+2];
    var tt=((p2*7919)+((p2*104729)%13))%M; var j=tt*5;
    aB[p2*3]=tgt[j]+(Math.random()-0.5)*0.004; aB[p2*3+1]=tgt[j+1]+(Math.random()-0.5)*0.004; aB[p2*3+2]=(Math.random()-0.5)*1.6;
    var cr2=tgt[j+2], cg3=tgt[j+3], cb3=tgt[j+4], lb=0.299*cr2+0.587*cg3+0.114*cb3;
    var lift=Math.max(0, 0.30-lb);
    colB[p2*3]=Math.min(1, cr2*0.55+0.243+lift); colB[p2*3+1]=Math.min(1, cg3*0.55+0.151+lift); colB[p2*3+2]=Math.min(1, cb3*0.55+0.5+lift);
    seed[p2*4]=ts[p2]; seed[p2*4+1]=0.6+Math.random(); seed[p2*4+2]=Math.random()*6.283; seed[p2*4+3]=0.45+Math.random();
  }
  renderer = new THREE.WebGLRenderer({canvas:CV, alpha:true, antialias:false, powerPreference:'high-performance'});
  renderer.setPixelRatio(DPR);
  scene = new THREE.Scene();
  cam = new THREE.OrthographicCamera(-W/2,W/2,H/2,-H/2,-3000,3000);
  uni = { uPm:{value:0}, uT:{value:0}, uSizeA:{value:new THREE.Vector2(W,H)}, uSizeB:{value:new THREE.Vector4(H*0.52,H*0.52,0,H*0.03)}, uZ:{value:H*0.09}, uPix:{value:DPR*(MOBILE?1.2:1.3)}, uRotB:{value:0}, uEnd:{value:0} };
  var vsh = [
  'uniform float uPm; uniform float uT; uniform vec2 uSizeA; uniform vec4 uSizeB; uniform float uZ; uniform float uPix; uniform float uRotB; uniform float uEnd;',
  'attribute vec3 aB; attribute vec3 aColA; attribute vec3 aColB; attribute vec4 aSeed;',
  '#ifdef TAIL',
  'attribute float aEnd; varying float vEnd;',
  '#endif',
  'varying vec3 vCol; varying float vA;',
  'float ssf(float a,float b,float x){ x=clamp((x-a)/(b-a),0.0,1.0); return x*x*(3.0-2.0*x); }',
  'float bell(float x){ return ssf(0.0,0.28,x)*(1.0-ssf(0.72,1.0,x)); }',
  'float fOf(float pm){ return clamp((pm - aSeed.x*0.62)/0.38, 0.0, 1.0); }',
  'vec3 calc(float f){',
  ' float e=f*f*(3.0-2.0*f);',
  ' vec3 pA=vec3((position.x-0.5)*uSizeA.x,(0.5-position.y)*uSizeA.y,position.z*uZ);',
  ' float bx=(aB.x-0.5)*uSizeB.x; float bz=aB.z*uZ*1.5;',
  ' float cr=cos(uRotB); float sr=sin(uRotB);',
  ' vec3 pB=vec3(bx*cr-bz*sr+uSizeB.z,(0.5-aB.y)*uSizeB.y+uSizeB.w,bx*sr+bz*cr);',
  ' vec3 base=mix(pA,pB,e);',
  ' float fl=bell(f);',
  ' vec3 sw=vec3(sin(uT*aSeed.y+aSeed.z+f*8.0),cos(uT*0.9*aSeed.y+aSeed.z*1.7+f*6.0),sin(uT*0.7+aSeed.z*2.3));',
  ' sw*=uSizeA.y*0.10*fl*aSeed.w;',
  ' sw.y-=uSizeA.y*0.16*fl;',
  ' float idle=ssf(0.94,1.0,uPm);',
  ' base+=vec3(sin(uT*0.8+aSeed.z),cos(uT*0.6+aSeed.z*2.0),0.0)*2.0*idle;',
  ' return base+sw;',
  '}',
  'void main(){',
  ' float f=fOf(uPm);',
  ' float fl=bell(f);',
  ' vec3 pos=calc(f);',
  '#ifdef TAIL',
  ' vEnd=aEnd; if(aEnd>0.5){ pos=calc(max(f-0.05,0.0)); }',
  '#endif',
  ' vec3 vio=vec3(0.486,0.302,1.0);',
  ' vec3 c=mix(aColA,vio,min(fl*1.5,1.0));',
  ' c=mix(c,aColB,ssf(0.72,1.0,f));',
  ' c+=vec3(0.9,0.85,1.0)*fl*0.22;',
  ' vCol=c;',
  ' float aFly=fl*(0.65+0.35*aSeed.w);',
  ' float aSet=ssf(0.9,1.0,f)*0.85*(1.0-uEnd*0.62);',
  ' vA=max(aFly,aSet);',
  ' gl_Position=projectionMatrix*modelViewMatrix*vec4(pos,1.0);',
  ' gl_PointSize=uPix*(1.05+0.9*fl+0.5*ssf(0.9,1.0,f));',
  '}'].join(String.fromCharCode(10));
  var fshP = 'varying vec3 vCol; varying float vA;\nvoid main(){ vec2 q=gl_PointCoord-0.5; float d=length(q); float a=smoothstep(0.5,0.1,d)*vA; if(a<0.004) discard; gl_FragColor=vec4(vCol,a); }';
  var fshL = 'varying vec3 vCol; varying float vA; varying float vEnd;\nvoid main(){ float a=vA*0.4*(1.0-vEnd*0.85); if(a<0.004) discard; gl_FragColor=vec4(vCol,a); }';
  var gP = new THREE.BufferGeometry();
  gP.setAttribute('position', new THREE.BufferAttribute(pos,3));
  gP.setAttribute('aB', new THREE.BufferAttribute(aB,3));
  gP.setAttribute('aColA', new THREE.BufferAttribute(colA,3));
  gP.setAttribute('aColB', new THREE.BufferAttribute(colB,3));
  gP.setAttribute('aSeed', new THREE.BufferAttribute(seed,4));
  var mP = new THREE.ShaderMaterial({uniforms:uni, vertexShader:vsh, fragmentShader:fshP, transparent:true, depthTest:false, depthWrite:false, blending:THREE.AdditiveBlending});
  pts = new THREE.Points(gP, mP); scene.add(pts);
  if(!MOBILE){
    var pos2=new Float32Array(N*6), aB2=new Float32Array(N*6), cA2=new Float32Array(N*6), cB2=new Float32Array(N*6), sd2=new Float32Array(N*8), en2=new Float32Array(N*2);
    for(var q=0;q<N;q++){ for(var e3=0;e3<2;e3++){ var d3=(q*2+e3)*3, s3=q*3, d4=(q*2+e3)*4, s4=q*4;
      pos2[d3]=pos[s3]; pos2[d3+1]=pos[s3+1]; pos2[d3+2]=pos[s3+2];
      aB2[d3]=aB[s3]; aB2[d3+1]=aB[s3+1]; aB2[d3+2]=aB[s3+2];
      cA2[d3]=colA[s3]; cA2[d3+1]=colA[s3+1]; cA2[d3+2]=colA[s3+2];
      cB2[d3]=colB[s3]; cB2[d3+1]=colB[s3+1]; cB2[d3+2]=colB[s3+2];
      sd2[d4]=seed[s4]; sd2[d4+1]=seed[s4+1]; sd2[d4+2]=seed[s4+2]; sd2[d4+3]=seed[s4+3];
      en2[q*2+e3]=e3; } }
    var gL = new THREE.BufferGeometry();
    gL.setAttribute('position', new THREE.BufferAttribute(pos2,3));
    gL.setAttribute('aB', new THREE.BufferAttribute(aB2,3));
    gL.setAttribute('aColA', new THREE.BufferAttribute(cA2,3));
    gL.setAttribute('aColB', new THREE.BufferAttribute(cB2,3));
    gL.setAttribute('aSeed', new THREE.BufferAttribute(sd2,4));
    gL.setAttribute('aEnd', new THREE.BufferAttribute(en2,1));
    var mL = new THREE.ShaderMaterial({uniforms:uni, vertexShader:'#define TAIL'+String.fromCharCode(10)+vsh, fragmentShader:fshL, transparent:true, depthTest:false, depthWrite:false, blending:THREE.AdditiveBlending});
    lines = new THREE.LineSegments(gL, mL); scene.add(lines);
  }
  renderer.setSize(W,H,false);
  IMG.style.opacity='0'; ER.style.opacity='1'; CV.style.opacity='1';
  imgW=imA.naturalWidth; imgH=imA.naturalHeight;
  built=true;
  if(SCRUB){ try{
    VID=document.createElement("video"); VID.muted=true; VID.setAttribute("muted",""); VID.playsInline=true; VID.setAttribute("playsinline",""); VID.preload="auto";
    VID.addEventListener("loadedmetadata", function(){ vidDur=VID.duration||0; });
    VID.addEventListener("canplaythrough", function(){ if(vidDur>0.5) vidReady=true; });
    VID.addEventListener("seeked", function(){ vidSeeking=false; });
    VID.addEventListener("error", function(){ VID=null; vidReady=false; });
    VID.src=SCRUB; VID.load();
  }catch(e){} }
}
function buildLayers(imA){
  var cov=ER.__cov;
  var bg=document.createElement('canvas'); bg.width=W; bg.height=H;
  var bx=bg.getContext('2d');
  try { bx.filter='blur(3px) brightness(0.92)'; } catch(e){}
  bx.drawImage(imA,cov[0],cov[1],cov[2],cov[3],-10,-10,W+20,H+20);
  try { bx.filter='none'; } catch(e){}
  bgL=bg;
  rainP=[]; for(var r2=0;r2<64;r2++){ rainP.push({x:Math.random(), y:Math.random(), s:0.6+Math.random(), l:10+Math.random()*16}); }
  (new Function('u','return import(u)'))('https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.14/+esm').then(function(mp){
    return mp.FilesetResolver.forVisionTasks('https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.14/wasm').then(function(files){
      return mp.ImageSegmenter.createFromOptions(files,{baseOptions:{modelAssetPath:'https://storage.googleapis.com/mediapipe-models/image_segmenter/selfie_segmenter/float16/latest/selfie_segmenter.tflite'},runningMode:'IMAGE',outputConfidenceMasks:true});
    });
  }).then(function(seg){
    var oc=document.createElement('canvas'); oc.width=W; oc.height=H;
    oc.getContext('2d').drawImage(imA,cov[0],cov[1],cov[2],cov[3],0,0,W,H);
    var res=seg.segment(oc);
    var m=res.confidenceMasks && res.confidenceMasks[0];
    if(m){
      var mw=m.width, mh=m.height, md=m.getAsFloat32Array();
      var mc=document.createElement('canvas'); mc.width=mw; mc.height=mh;
      var mx2=mc.getContext('2d'); var mi=mx2.createImageData(mw,mh);
      for(var i=0;i<mw*mh;i++){ var a=md[i]; mi.data[i*4+3]=a>0.35?Math.min(255,Math.round((a-0.35)/0.30*255)):0; }
      mx2.putImageData(mi,0,0);
      var sc=document.createElement('canvas'); sc.width=W; sc.height=H;
      var sx2=sc.getContext('2d');
      sx2.drawImage(oc,0,0);
      sx2.globalCompositeOperation='destination-in';
      sx2.drawImage(mc,0,0,W,H);
      subL=sc;
    }
    if(res && res.close) res.close();
  }).catch(function(e){ window.__morphErr2='seg:'+String(e&&e.message).slice(0,90); });
}
function drawErode(pm){
  if(!built) return;
  var doHoles=false;
  if(pm > pmBaked + 0.0005){ doHoles=true; pmBaked=pm; }
  else if(pm < pmBaked - 0.015){
    hx2.clearRect(0,0,holes.width,holes.height);
    for(var i0=0;i0<PLH.length;i0++){ PLH[i0].baked=0; }
    doHoles=true; pmBaked=pm;
  }
  var i,pt,f,al,s2, BW=brush.width*1.9;
  if(doHoles) for(i=0;i<PLH.length;i++){ pt=PLH[i]; if(pt.baked) continue;
    f=(pm - pt.t*0.62)/0.38; if(f<=0) continue;
    if(f>=0.5){ pt.baked=1; f=0.5; }
    al=Math.min(1, f*2.4);
    s2=BW*(0.5+0.6*Math.min(1,f*2.0))*0.5;
    hx2.globalAlpha=al;
    hx2.drawImage(brush, pt.hx*0.5-s2/2, pt.hy*0.5-s2/2, s2, s2);
  }
  hx2.globalAlpha=1;
  var cov=ER.__cov;
  var tS=(performance.now()-t0)/1000;
  ex.globalCompositeOperation='source-over';
  ex.clearRect(0,0,W,H);
  if(vidReady && VID && VID.readyState>=2){
    var vw=VID.videoWidth, vh2=VID.videoHeight;
    var vs=Math.max(W/vw, H/vh2), vdw=vw*vs, vdh=vh2*vs;
    ex.drawImage(VID, (W-vdw)/2, (H-vdh)/2, vdw, vdh);
  } else {
  var par=ss(0,0.5,pm);
  if(bgL){
    var bs=1.035+0.05*par;
    ex.save(); ex.translate(W/2, H/2 - 12*par); ex.scale(bs,bs); ex.drawImage(bgL,-W/2,-H/2); ex.restore();
  } else {
    ex.drawImage(ER.__img, cov[0],cov[1],cov[2],cov[3], 0,0,W,H);
  }
  if(subL){
    var ssc=1+0.018*par;
    ex.save(); ex.translate(W/2, H/2 + 7*par); ex.scale(ssc,ssc); ex.drawImage(subL,-W/2,-H/2); ex.restore();
  }
  if(degraded<2 && rainP){
    ex.save(); ex.lineWidth=1; ex.strokeStyle='rgba(205,200,235,1)';
    for(var rp=0; rp<rainP.length; rp++){ var d2=rainP[rp];
      var ry2=((d2.y + tS*(0.18+0.16*d2.s)) % 1.06)*H - 20;
      var rx2=((d2.x + tS*0.006) % 1)*W;
      ex.globalAlpha=0.04+0.08*d2.s;
      ex.beginPath(); ex.moveTo(rx2, ry2); ex.lineTo(rx2-2, ry2+d2.l); ex.stroke();
    }
    ex.restore(); ex.globalAlpha=1;
    var gl = ss(0.01,0.10,pm)*(1-ss(0.18,0.32,pm));
    if(gl>0.01){
      var gx=W*(0.25+0.5*ss(0.01,0.30,pm));
      var gr2=ex.createLinearGradient(gx-90,0,gx+90,0);
      gr2.addColorStop(0,'rgba(160,120,255,0)'); gr2.addColorStop(0.5,'rgba(190,160,255,'+(0.16*gl).toFixed(3)+')'); gr2.addColorStop(1,'rgba(160,120,255,0)');
      ex.fillStyle=gr2; ex.fillRect(gx-90, 0, 180, H*0.72);
    }
  }
  }
  ex.globalCompositeOperation='destination-out';
  ex.drawImage(holes,0,0,W,H);
  ex.globalCompositeOperation='source-over';
  if(pm>0.01&&pm<0.92&&degraded<2){
    var fy=clamp(pm/0.62,0,1.04)*H;
    var gr=ex.createLinearGradient(0,fy-60,0,fy+60);
    gr.addColorStop(0,'rgba(124,77,255,0)'); gr.addColorStop(0.5,'rgba(124,77,255,0.12)'); gr.addColorStop(1,'rgba(124,77,255,0)');
    ex.fillStyle=gr; ex.fillRect(0,fy-60,W,120);
    ex.globalAlpha=0.5; ex.fillStyle='rgba(196,168,255,0.55)'; ex.fillRect(0,fy-0.7,W,1.4); ex.globalAlpha=1;
  }
}
function applyP(p){
  var pm = clamp((p-0.06)/0.82, 0, 1);
  var pmE = pm;
  if(vidReady && VID){
    vidTarget = Math.min(Math.max(0.01, vidDur-0.05), (Math.min(pm,VSEG)/VSEG)*vidDur);
    var vNow = performance.now();
    if(vidSeeking && (vNow - vidSeekT) > 250){ vidSeeking = false; }
    if(!vidSeeking){
      var cur = VID.currentTime;
      var step = (vidTarget - cur) * 0.24;
      if(Math.abs(step) > 0.6) step = step > 0 ? 0.6 : -0.6;
      var nxt = cur + step;
      if(Math.abs(nxt - cur) > 0.018){
        vidSeeking = true; vidSeekT = vNow;
        try { VID.currentTime = nxt; } catch(e){ vidSeeking = false; }
      }
    }
    pmE = clamp((pm-VSEG)/(1-VSEG), 0, 1);
  }
  uni.uPm.value=pmE;
  uni.uRotB.value=Math.sin(uni.uT.value*0.3)*0.12;
  var end = ss(0.90,0.985,p);
  uni.uEnd.value=end;
  drawErode(pmE); lastPm=pmE;
  if(INNER){ var to=1-ss(0.05,0.16,p); INNER.style.opacity=to; INNER.style.pointerEvents=p>0.2?'none':''; }
  if(CUE){ CUE.style.opacity=1-ss(0.02,0.08,p); }
  if(ENDCAP){ ENDCAP.style.opacity=ss(0.86,0.97,p); ENDCAP.style.pointerEvents = (ss(0.86,0.97,p)) > 0.5 ? "auto" : "none"; ENDCAP.setAttribute("aria-hidden", (ss(0.86,0.97,p)) > 0.5 ? "false" : "true"); }
  if(GPNG){ GPNG.style.opacity=end;
    GPNG.style.transform='translate(-50%,-50%) translateY('+(Math.sin(uni.uT.value*0.8)*5*end).toFixed(1)+'px) rotate('+(Math.sin(uni.uT.value*0.3)*1.2*end).toFixed(2)+'deg)';
  }
  renderer.render(scene,cam);
}
function computeP(){ var r=SEC.getBoundingClientRect(); var vh=VHC; var tot=r.height-vh;
  if(tot<50) return 0; return clamp(-r.top/tot,0,1); }
function frame(ts){ raf=requestAnimationFrame(frame);
  if(!built||failed) return;
  var dt=ts-lastT; lastT=ts;
  if(dt>0&&dt<500){ fpsE=fpsE*0.95+(1000/dt)*0.05;
    if(fpsE<26&&degraded<2){ degraded++; if(degraded===1&&lines){ lines.visible=false; } else { renderer.setPixelRatio(1); } fpsE=40; } }
  var r=SEC.getBoundingClientRect();
  if(r.bottom<-100||r.top>VHC+100){ if(CV.style.visibility!=='hidden'){CV.style.visibility='hidden'; ER.style.visibility='hidden';} return; }
  if(CV.style.visibility==='hidden'){CV.style.visibility='visible'; ER.style.visibility='visible';}
  var p=(window.__morphHold!=null)?window.__morphHold:computeP();
  uni.uT.value=(ts-t0)/1000;
  applyP(p);
  lastP=p;
}
window.__morphSeek = function(p){ if(!built) return 'not built'; uni.uT.value=(performance.now()-t0)/1000; applyP(p); return 'ok'+p; };
function start(){
  loadThree(function(){ if(failed||!window.THREE) return;
    Promise.all([loadImg(IMG.currentSrc||IMG.src), loadImg(GURL)]).then(function(ims){
      /* SX-LATEPIN v2: pina antes de medir, pro canvas nascer no tamanho do scrub */
      var rr0=SEC.getBoundingClientRect(); if(rr0.bottom>40){ SEC.classList.add('sh-scrub'); void SEC.offsetHeight; }
      try{ build(ims[0],ims[1]); }catch(e){ failed=true; window.__morphErr=String(e&&e.message)+'|'+String(e&&e.stack).slice(0,400); }
      if(failed){ SEC.classList.remove('sh-scrub'); IMG.style.opacity=''; return; }
      window.__shReady=1;
      raf=requestAnimationFrame(frame);
    }).catch(function(err){ window.__morphErr='P:'+String(err&&err.message); SEC.classList.remove('sh-scrub'); });
  });
}
var kicked=false;
function kick(){ if(kicked) return; kicked=true; start(); }
if('IntersectionObserver' in window){
  var io=new IntersectionObserver(function(es){ es.forEach(function(en){ if(en.isIntersecting) { io.disconnect(); kick(); } }); },{rootMargin:'600px'});
  io.observe(SEC);
} else { kick(); }
setTimeout(function(){ if(!kicked){ var rr=SEC.getBoundingClientRect(); if(rr.bottom>-600 && rr.top<VHC+600) kick(); } }, 1400);
var rto; var lastW=innerWidth; addEventListener('orientationchange', function(){ VHC = window.innerHeight; });
window.addEventListener('resize', function(){ clearTimeout(rto); rto=setTimeout(function(){ if(Math.abs(innerWidth-lastW)>60 && built){ lastW=innerWidth; location.reload(); } },700); });

/* SX-VHCUP */ (function(){ var w0 = window.innerWidth; window.addEventListener("resize", function(){ if(Math.abs(window.innerWidth - w0) > 60){ w0 = window.innerWidth; VHC = window.innerHeight; } }, {passive:true}); })();
})();